import registrationApi from './registration-api';

export * from './models';

export default registrationApi;
